import React from 'react'
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { useState, useEffect } from "react";

const ArtistForm = ({
    initialValues,
    validationSchema,
    handleFormSubmit,
    closeModal,
    FormComponent,
    updateTitle,
    addTitle,
    subTitle,
    extraProps,
    relationData,
}) => {
    return (
        <>
            <Modal.Header>
                <Modal.Title>
                    {initialValues?._id ? updateTitle : addTitle}
                    {subTitle ? <span className="sub-title"> {subTitle}</span> : null}
                </Modal.Title>
                {closeModal ? (
                    <button
                        type="button"
                        className="btn-close"
                        data-dismiss="modal"
                        onClick={closeModal}
                    ></button>
                ) : null}
            </Modal.Header>

            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                validate={extraProps?.validate ? extraProps?.validate : null}
                onSubmit={handleFormSubmit}
            >
                {(formik) => (
                    <Form>
                        <Modal.Body>
                            <FormComponent
                                formik={formik}
                                extraProps={extraProps}
                                relationData={relationData}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="submit"
                                className="btn me-2 btn-primary"
                                disabled={formik.isSubmitting}
                            >
                                {initialValues?._id ? "Update" : "Save"}
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default ArtistForm